<template>
  <div class="index-manage container-build">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img src="../../static/index/manage/manage-icon.png" />
        </div>
        经营必备
      </div>
      <!-- <div class="head-right">
        查看更多
        <div class="icon"></div>
      </div> -->
    </div>
    <div class="manage-list row">
      <div
        class="col-lg-3 col-xs-3"
        v-for="item in manage.slice(0, 4)"
        :key="item.id"
      >
        <div class="manage-item" @click="golink(item.linkUrl)">
          <div class="item-title-1">{{ item.title }}</div>
          <div class="item-title-2">{{ item.subtitle }}</div>
          <div
            class="item-icon"
            :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"
          >
            <!-- <img :src="item.imgUrl" /> -->
          </div>
        </div>
      </div>

      <div
        class="col-lg-6  col-xs-6"
        v-for="item in manage.slice(4, 6)"
        :key="item.id"
      >
        <div class="manage-item-2" @click="golink(item.linkUrl)">
          <div class="item-title-1">{{ item.title }}</div>
          <div class="item-title-2">{{ item.subtitle }}</div>
          <div
            class="item-icon"
            :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"
          >
            <!-- <img :src="item.imgUrl" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["manage"],
  data() {
    return {};
  },
  methods: {
    golink(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.index-manage {
  margin: auto;
  flex-direction: column;

  .manage-list {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0;
    .col-lg-3 {
      padding: 0 0.05rem;
    }
    .col-lg-6 {
      padding: 0 0.05rem;
    }

    .manage-item {
      flex-direction: column;
      height: 2.04rem;
      background-color: #fff;
      box-shadow: 0px 0.02rem 0.1rem 0px rgba(54, 54, 54, 0.1);
      border-radius: 0.12rem;
      padding: 0.25rem 0;
      margin-bottom: 0.2rem;
      position: relative;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .item-title-1 {
        color: #1b1c33;
        font-size: 0.2rem;
        line-height: 0.28rem;
        font-weight: 500;
        margin-bottom: 0.05rem;
        justify-content: center;
      }

      .item-title-2 {
        color: #5e5e66;
        font-size: 0.16rem;
        line-height: 0.22rem;
        justify-content: center;
      }

      .item-icon {
        width: 100%;
        height: 100%;
        justify-content: center;
        margin: auto;
        position: absolute;
        top: -0.1rem;
        left: 0;
        background-size: 1.03rem 0.97rem;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        img {
          width: 100%;
        }
      }
      @media (max-width: 991px) {
        .item-title-1 {
          color: #1b1c33;
          font-size: 0.26rem;
          line-height: 0.33rem;
          font-weight: bolder;
          margin-bottom: 0rem;
          justify-content: center;
        }

        .item-title-2 {
          color: #5e5e66;
          font-size: 0.26rem;
          line-height: 0.3rem;
          justify-content: center;
        }
      }
    }

    .manage-item-2 {
      flex-direction: column;
      height: 2.04rem;
      background-color: #fff;
      box-shadow: 0px 0.02rem 0.1rem 0px rgba(54, 54, 54, 0.1);
      border-radius: 0.12rem;
      padding: 0.25rem 0;
      margin-bottom: 0.2rem;
      position: relative;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .item-title-1 {
        font-size: 0.2rem;
        line-height: 0.28rem;
        font-weight: 500;
        margin-bottom: 0.05rem;
        justify-content: center;
      }

      .item-title-2 {
        color: #5e5e66;
        font-size: 0.16rem;
        line-height: 0.22rem;
        justify-content: center;
      }

      .item-icon {
        width: 100%;
        height: 100%;
        justify-content: center;
        margin: auto;
        position: absolute;
        top: -0.1rem;
        left: 0;
        background-size: 1.56rem 1.07rem;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        img {
          width: 100%;
        }
      }
      @media (max-width: 991px) {
        .item-title-1 {
          color: #1b1c33;
          font-size: 0.26rem;
          line-height: 0.33rem;
          font-weight: bolder;
          margin-bottom: 0rem;
          justify-content: center;
        }

        .item-title-2 {
          color: #5e5e66;
          font-size: 0.26rem;
          line-height: 0.3rem;
          justify-content: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexmanage.vue